module.exports = __webpack_public_path__ + "static/media/back-button.bfaf6b02.png";